import React from 'react'
import PropTypes from 'prop-types'
import Link from 'components/Link'
import { Eyebrow } from 'components/Typography'
import Button from 'components/Button'
import { Container, Spacing50 } from 'styles/sharedStyle'
import theme from 'styles/theme'
import trackGTM from 'utils/trackGTM'
import scrollTo from 'utils/scrollTo'

import { Item, ItemList, ButtonWrapper, Header } from './Contact.style'

const Contact = ({
  email,
  emailLabel,
  phone,
  phoneLabel,
  title,
  website,
  websiteLabel,
  viewMapLabel,
  viewMapUrl,
  facebook,
  facebookLabel,
  twitter,
  twitterLabel,
  pinterest,
  pinterestLabel,
  instagram,
  instagramLabel,
}) => {
  const websiteDisplay = (url) => {
    if (url) {
      return url.replace(/http(s?):\/\//g, '')
    }
    return null
  }

  const onScrollTop = () => {
    scrollTo(0, 0)
  }

  const hasCTA = !!(viewMapLabel && viewMapUrl)
  const hasTitle = !!title
  const hasContent = !!(
    phone ||
    website ||
    email ||
    facebook ||
    twitter ||
    pinterest ||
    instagram
  )
  const hasLabels = !!(
    phoneLabel ||
    websiteLabel ||
    emailLabel ||
    hasCTA ||
    facebookLabel ||
    twitterLabel ||
    pinterestLabel ||
    instagramLabel
  )

  return hasTitle && hasContent && hasLabels ? (
    <Container p={`0 ${theme.space[4]}`} textAlign="center">
      <Spacing50 />
      {hasTitle && hasContent && (
        <>
          <Header>{title}</Header>
        </>
      )}
      {hasContent && (
        <>
          <ItemList>
            {phone && phoneLabel && (
              <Item>
                <Eyebrow as="dt">{`${phoneLabel}:`}</Eyebrow>
                <dd>
                  <Link external to={`tel:${phone}`}>
                    {phone}
                  </Link>
                </dd>
              </Item>
            )}
            {website && websiteLabel && (
              <Item>
                <Eyebrow as="dt">{`${websiteLabel}:`}</Eyebrow>
                <dd>
                  <Link
                    onClick={() =>
                      trackGTM(
                        'outbound link',
                        'navigation',
                        'offsite link',
                        website
                      )
                    }
                    external
                    showIcon
                    to={website}>
                    {websiteDisplay(website)}
                  </Link>
                </dd>
              </Item>
            )}
            {facebook && facebookLabel && (
              <Item>
                <Eyebrow as="dt">{`${facebookLabel}:`}</Eyebrow>
                <dd>
                  <Link
                    onClick={() =>
                      trackGTM(
                        'outbound link',
                        'navigation',
                        'offsite link',
                        facebook
                      )
                    }
                    external
                    showIcon
                    to={facebook}>
                    {websiteDisplay(facebook)}
                  </Link>
                </dd>
              </Item>
            )}
            {twitter && twitterLabel && (
              <Item>
                <Eyebrow as="dt">{`${twitterLabel}:`}</Eyebrow>
                <dd>
                  <Link
                    onClick={() =>
                      trackGTM(
                        'outbound link',
                        'navigation',
                        'offsite link',
                        twitter
                      )
                    }
                    external
                    showIcon
                    to={twitter}>
                    {websiteDisplay(twitter)}
                  </Link>
                </dd>
              </Item>
            )}
            {pinterest && pinterestLabel && (
              <Item>
                <Eyebrow as="dt">{`${pinterestLabel}:`}</Eyebrow>
                <dd>
                  <Link
                    onClick={() =>
                      trackGTM(
                        'outbound link',
                        'navigation',
                        'offsite link',
                        pinterest
                      )
                    }
                    external
                    showIcon
                    to={pinterest}>
                    {websiteDisplay(pinterest)}
                  </Link>
                </dd>
              </Item>
            )}
            {instagram && instagramLabel && (
              <Item>
                <Eyebrow as="dt">{`${instagramLabel}:`}</Eyebrow>
                <dd>
                  <Link
                    onClick={() =>
                      trackGTM(
                        'outbound link',
                        'navigation',
                        'offsite link',
                        instagram
                      )
                    }
                    external
                    showIcon
                    to={instagram}>
                    {websiteDisplay(instagram)}
                  </Link>
                </dd>
              </Item>
            )}
            {email && emailLabel && (
              <Item>
                <Eyebrow as="dt">{`${emailLabel}:`}</Eyebrow>
                <dd>
                  <Link external to={`mailto:${email}`}>
                    {email}
                  </Link>
                </dd>
              </Item>
            )}
          </ItemList>
        </>
      )}
      {hasCTA && (
        <>
          <ButtonWrapper>
            <Button
              as={Link}
              to={viewMapUrl}
              onClick={onScrollTop}
              level="tertiary"
              fixedSize>
              {viewMapLabel}
            </Button>
          </ButtonWrapper>
        </>
      )}
      <Spacing50 />
    </Container>
  ) : null
}

Contact.propTypes = {
  title: PropTypes.string,
  email: PropTypes.string,
  emailLabel: PropTypes.string,
  phone: PropTypes.string,
  phoneLabel: PropTypes.string,
  website: PropTypes.string,
  websiteLabel: PropTypes.string,
  viewMapLabel: PropTypes.string,
  viewMapUrl: PropTypes.string,
  facebook: PropTypes.string,
  facebookLabel: PropTypes.string,
  twitter: PropTypes.string,
  twitterLabel: PropTypes.string,
  pinterest: PropTypes.string,
  pinterestLabel: PropTypes.string,
  instagram: PropTypes.string,
  instagramLabel: PropTypes.string,
}

Contact.defaultProps = {
  title: null,
  email: null,
  emailLabel: null,
  phone: null,
  phoneLabel: null,
  website: null,
  websiteLabel: null,
  viewMapLabel: null,
  viewMapUrl: null,
  facebook: null,
  facebookLabel: null,
  twitter: null,
  twitterLabel: null,
  pinterest: null,
  pinterestLabel: null,
  instagram: null,
  instagramLabel: null,
}

export default Contact
